function validateDOB() {
    const dobNode = document.getElementById('yearOfBirth');
    if (dobNode) {
        const newValue = dobNode.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1') * 1;
        dobNode.value = Math.min(newValue, new Date().getFullYear());
    }
}

// function validateCustomer() {
//     if (!checkStorage('customer_validate')) {
//         setStorage("customer_validate", "yes", 0.0104);
//     }
// }

function removeCustomer() {
    removeStorage("customer_validate");
}

addEventListener("DOMContentLoaded", function() {
    if (!checkStorage('customer_validate')) {
        document.documentElement.classList.add('modal-open');
        document.querySelector('.c-modal-popup').style.display = 'block';
        document.querySelector('body').style.opacity = '100';
    } else {
        document.querySelector('body').style.opacity = '100';
    }

    document.querySelectorAll('.c-modal-popup__action form input, .c-modal-popup__action form input').forEach(function(element) {
        element.addEventListener("change", validateForm);
        element.addEventListener("keyup", validateForm);
        element.addEventListener("paste", validateForm);
    });

    document.querySelectorAll('.c-modal-popup__action form input, .c-modal-popup__action form select').forEach(function(element) {
        element.addEventListener("change", validateForm);
    });

    function validateForm(e) {
        let valid = false

        if(e.target.tagName === 'INPUT') {
            valid = true
        }

        if (!valid) {
            return
        }

        const yod_input = document.querySelector('.c-modal-popup__action form input');
        const yearOfBirth = parseInt(document.querySelector('.c-modal-popup__action form input').value);
        const currentYear = new Date().getFullYear();
        const country = document.querySelector('.c-modal-popup__action--select option:checked').value;
        const error_message = document.querySelector('.c-modal-popup__error-message');
        const actionBtn = document.querySelector('.c-modal-popup__action-btn');

        if(yearOfBirth.toString().length < 4) {
            actionBtn.setAttribute("disabled", true);
            actionBtn.classList.add("u-button-disabled");

            return
        }

        if (country !== '' && yearOfBirth) {
            let age = currentYear - yearOfBirth;
            let minAge = country === 'AU' || country === 'HK' ? 18 : 18;
            let isValidAge = age >= minAge && age <= 130;

            if (isValidAge) {
                yod_input.classList.remove('error-input');
                actionBtn.removeAttribute("disabled");
                actionBtn.classList.remove("u-button-disabled");
                error_message.classList.add('opacity-0');
            } else {
                yod_input.classList.add('error-input');
                actionBtn.setAttribute("disabled", true);
                actionBtn.classList.add("u-button-disabled");
                error_message.classList.remove('opacity-0');
            }
        } else {
            const actionBtn = document.querySelector('.c-modal-popup__action-btn');
            if (!actionBtn.classList.contains('u-button-disabled')) {
                yod_input.classList.add('error-input');
                actionBtn.setAttribute("disabled", true);
                actionBtn.classList.add("u-button-disabled");
                error_message.classList.remove('opacity-0');
            }
        }
    }

    document.querySelector('.c-modal-popup__action-btn').onclick = function(e) {
        e.preventDefault();
        document.querySelector('body').style.opacity = 0;
        document.querySelector('.shopify-section--popup').style.display = 'none';
        document.documentElement.classList.remove('modal-open');

        const yearOfBirth = parseInt(document.querySelector('.c-modal-popup__action form input').value);
        const country = document.querySelector('.c-modal-popup__action--select option:checked').innerHTML;

        const userData = {
          country: country,
          value: "true"
        };
        
        sessionStorage.setItem("rememberageconsent", JSON.stringify(userData));

        setStorage("customer_validate", country, 1);


        if (country === 'Norway') {
            window.location.href = 'https://wineinmoderation.eu/';
        } else {
            document.querySelector('.shopify-section--popup').style.display = 'none';
            document.documentElement.classList.remove('modal-open');
            document.querySelector('body').style.opacity = 1;
        }
    }

    document.addEventListener("keypress", function(e) {
        if (!document.querySelector('.c-modal-popup__action-btn.u-button-disabled')) {
            if (e.key === "Enter") {
                document.querySelector('.c-modal-popup__action-btn').click();
                return false;
            }
        }
    });
    
    // if (customer_expired || sessionStorage.getItem('rememberageconsent') != null) {
    //     if (checkStorage('customer_validate') && sessionStorage.getItem('rememberageconsent') === null) {
    //         document.querySelector('.c-age-gate').classList.add('c-validate');
    //         document.querySelector('.confirm-auth').classList.remove('hidden');
    //         document.querySelector('.c-modal-popup__action form').classList.add('hidden');

    //         document.querySelector('.c-modal-popup').style.display = 'block';

    //         const userData = getStorage('customer_validate')
            
    //         sessionStorage.setItem("rememberageconsent", JSON.stringify(userData));

    //         setTimeout(() => {
    //             document.querySelector('.shopify-section--popup').style.display = 'none';
    //             document.querySelector('.confirm-auth').classList.add('hidden');
    //             document.querySelector('.c-modal-popup__action form').classList.remove('hidden');
    //         }, 6000)
    //     }
    // } else {
    //     removeStorage("customer_validate");
    // }
});

addEventListener("load", function() {
  if (JSON.parse(sessionStorage.getItem("rememberageconsent")).country == 'Norway') {
    window.location.href = 'https://wineinmoderation.eu/';
  }
})